import types from "../../utils/actionTypes";
import apis from "../api";
export const login = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: true },
  });
  const response = await apis.login(data);

  if (response && response.data !== null) {
    dispatch({
      type: types.SET_ACCOUNT_FIELD,
      field: {
        currentUser: {
          email: response.data.email,
        },
      },
    });
  }
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: false },
  });
  return response;
};
export const changePassword = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: true },
  });
  const response = await apis.changePassword(data);

  if (response && response.data !== null) {
    dispatch({
      type: types.SET_ACCOUNT_FIELD,
      field: {
        currentUser: {
          email: response.data.email,
        },
      },
    });
  }
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: false },
  });
  return response;
};


export const forgotPassword = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: true },
  });
  const response = await apis.forgotPassword(data);

  if (response && response.data !== null) {
    dispatch({
      type: types.SET_ACCOUNT_FIELD,
      field: {
        currentUser: {
          email: response.data.email,
        },
      },
    });
  }
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: false },
  });
  return response;
};
export const resetPassword = (data) => async (dispatch) => {
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: true },
  });
  const response = await apis.resetPassword(data);

  if (response && response.data !== null) {
    dispatch({
      type: types.SET_ACCOUNT_FIELD,
      field: {
        currentUser: {
          email: response.data.email,
        },
      },
    });
  }
  dispatch({
    type: types.SET_HOME_FIELD,
    field: { isBusy: false },
  });
  return response;
};

